__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "@oneaudi/fa-feature-app-wizard";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@oneaudi/oneaudi-os-authentication", "8.4.0", () => (Promise.all([__webpack_require__.e(939), __webpack_require__.e(318), __webpack_require__.e(259), __webpack_require__.e(678), __webpack_require__.e(882), __webpack_require__.e(848)]).then(() => (() => (__webpack_require__(2939))))));
			register("@oneaudi/oneaudi-os-react", "10.3.1", () => (Promise.all([__webpack_require__.e(318), __webpack_require__.e(259), __webpack_require__.e(678), __webpack_require__.e(882), __webpack_require__.e(720)]).then(() => (() => (__webpack_require__(6720))))));
			register("@oneaudi/unified-web-alpha-common", "2.2.1", () => (Promise.all([__webpack_require__.e(515), __webpack_require__.e(318), __webpack_require__.e(259)]).then(() => (() => (__webpack_require__(4515))))));
			register("@oneaudi/unified-web-alpha-components", "2.7.0", () => (Promise.all([__webpack_require__.e(377), __webpack_require__.e(318), __webpack_require__.e(259), __webpack_require__.e(676), __webpack_require__.e(678), __webpack_require__.e(934)]).then(() => (() => (__webpack_require__(4377))))));
			register("formik", "2.4.9", () => (Promise.all([__webpack_require__.e(233), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(8233))))));
			register("react-copy-to-clipboard", "5.1.1", () => (Promise.all([__webpack_require__.e(318), __webpack_require__.e(399)]).then(() => (() => (__webpack_require__(9399))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(961))))));
			register("react-router", "7.18.3", () => (Promise.all([__webpack_require__.e(638), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(6638))))));
			register("react-transition-group", "4.4.5", () => (Promise.all([__webpack_require__.e(310), __webpack_require__.e(318), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(6310))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(568), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(2568))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};